/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-05-18 14:54:31
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-07-15 15:33:45
 * @FilePath: /dsicm-admin-web/src/views/StandardDatabase/src/case-3/api/index.js
 */

import request from '@/utils/req.js';
// 检查
//新增检查分类
export function apiAddStandardCategroy(params) {
    return request.post("/admin/standard-category/insert",params);
}
//新增检查项目  分类下拉框获取
export function apiAddStandardCategroy_List(params) {
    return request.post("/admin/standard-category/list",params);
}
//新增检查项目  保存接口
export function apiAddExamineInfoInsert(params) {
    return request.post("/admin/examine-info/insert",params);
}

// 检查页面列表数据接口
export function apiExamineInfoList(params) {
    return request.post("/admin/examine-info/page",params);
}
// 检查页面列表数据 启用停用
export function apiPutUpdateStatus(params) {
    return request.put(`/admin/examine-info/updateStatus?id=${params}`);
}
//检查删除项目
export function apiDeleteStatus(params) {
    return request.delete(`/admin/examine-info/${params}`);
}
//检查项目编辑保存接口
export function apiExamineInfoUpdate(params) {
    return request.post("/admin/examine-info/update",params);
}

// 检验
//检验新增分类 上级分类下拉框数据
export function apiStandardInfoUpdate(params) {
    return request.post("/admin/standard-category/list",params);
}
//检验 主页列表数据接口
export function apiiInspectionInfo(params) {
    return request.post("/admin/inspection-info/page",params);
}
//检验 新增检验项目
export function apiAddInspection(params) {
    return request.post("/admin/inspection-info/insert",params);
}
//检验  项目启用停用
export function apiPutInspectionStatus(params) {
    return request.put(`/admin/inspection-info/updateStatus?id=${params}`);
}
//检验 删除项目
export function apiDeleteInspection(params) {
    return request.delete(`/admin/inspection-info/${params}`);
}
//检验 新增检验项目
export function apiUpdateInspection(params) {
    return request.post("/admin/inspection-info/update",params);
}

//治疗 分页列表查询
export function apiTreatmentList(params) {
    return request.post("/admin/treatment-info/page",params);
}
//治疗 项目启用停用
export function apiPutTreatmentStatus(params) {
    return request.put(`/admin/treatment-info/updateStatus?id=${params}`);
}
//治疗 项目删除
export function apiDeleteTreatment(params) {
    return request.delete(`/admin/treatment-info/${params}`);
}
//治疗 新增项目
export function apiTreatmentListAdd(params) {
    return request.post("/admin/treatment-info/insert",params);
}
//治疗 编辑项目更新
export function apiTreatmentListUpdate(params) {
    return request.post("/admin/treatment-info/update",params);
}
//治疗 新增项目 下拉框获取字典接口
export function apiCategoryChildren(code) {
    return request.get(`/admin/category/${code}/children`);
}

//获取对应检查部位
export function children(params={}){
    return request.get('admin/category/operate_position/children',params)
}



